module.exports = __webpack_public_path__ + "img/120.5.6c2f56bb.png";